export default "__VITE_ASSET__3660de59__"